<template>
  <div
    v-if="level!=0"
    class="mb4 gwnl-web-position-skills-progress"
  >
    <div class="gwnl-web-position-skills-progress-wrapper gwnl-web-position-skills-progress">
      <div
        class="bg-primary-6 mr8 gwnl-web-position-skills-progress-content"
        :style="{width:level*10+'%',background:color}"
      />
    </div>
    <div
      class="color-gray-9 standard-size-12 gwnl-web-position-skills-progress-index"
    >
      <yxt-tooltip
        effect="dark"
        open-filter
        :content="levelName"
        placement="top"
      >
        <span class="ellipsis levelName_maxWidth">{{ levelName }}</span>
      </yxt-tooltip>
      <span>{{ `（${range4show ? range4show : level}）` }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    level: {
      default: 0,
      type: Number
    },
    range4show: {
      type: String
    },
    color: {
      default: '#436bff',
      type: String
    },
    levelName: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
.levelName_maxWidth {
  display: inline-block;
  max-width: 80px;
}

.gwnl-web-position-skills-progress {
  display: flex;
  align-items: center;
}

.gwnl-web-position-skills-progress-wrapper {
  width: 68px;
  overflow: visible;
  white-space: nowrap;
}

.gwnl-web-position-skills-progress-content {
  display: inline-block;
  height: 6px;
  margin-right: 8px;
  vertical-align: middle;
  border-radius: 4px;
}

.gwnl-web-position-skills-progress-index {
  display: inline-flex;
  align-items: center;
}
</style>
